// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
// import VueAMap from 'vue-amap';
import 'lib-flexible'
// Vue.use(VueAMap)
// 初始化vue-amap
// VueAMap.initAMapApiLoader({
//   key: 'a91924536f87a1f720ef18197920658f',
//   // 高德 sdk 版本，默认为 1.4.4
//   v: '1.4.4'
// })

Vue.config.productionTip = false
Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js